import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {of} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {Region} from '../../user-dashboard/shared/region.model';
import {DecarbonizationType, DecarbonizationTypeRegion} from '../shared/decarbonization.model';

@Component({
  selector: 'app-decarbonization-type-list',
  templateUrl: './decarbonization-type-list.component.html',
  styleUrls: ['./decarbonization-type-list.component.scss']
})
export class DecarbonizationTypeListComponent implements OnChanges {

  public search = '';
  public displayedTypes: Array<DecarbonizationType | DecarbonizationTypeRegion> = [];
  public removableTypeIdsMap: Record<string, boolean>
  public regionsNameMap: Record<string, Region> = {};

  @Input() public regions: Array<Region> = [];
  @Input() public types: Array<DecarbonizationType | DecarbonizationTypeRegion> = [];
  @Input() public removableTypesId: Array<string> = [];
  @Input() public canCreateDecarbonizationTypes = false;
  @Input() public canManageRegionDecarbonizationTypes = false;

  @Input() public titleKey: string;
  @Input() public typeCreationButtonKey: string;
  @Input() public typeAddRegionButtonKey: string;
  @Input() public searchTitleKey: string;
  @Input() public searchPlaceholderKey: string;

  @Output() public openTypeCreationModal = new EventEmitter<void>();
  @Output() public openRegionTypeAddModal = new EventEmitter<void>();
  @Output() public deleteItem = new EventEmitter<DecarbonizationType>();
  @Output() public removeRegionItem = new EventEmitter<DecarbonizationTypeRegion>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('types')) {
      this.filterDisplayedTypes();
    }

    if (changes.hasOwnProperty('types') || changes.hasOwnProperty('removableTypesId')) {
      this.refreshRemovableTypesMap();
    }

    if (changes.hasOwnProperty('regions') && this.regions != null) {
      this.regionsNameMap = this.regions.reduce(
        (regionsNameMap, region) => ({...regionsNameMap, [region.id]: region.name}),
        {}
      );
    }
  }

  public filterDisplayedTypes() {
    of(this.search)
      .pipe(
        debounceTime(200)
      ).subscribe(searchedType => {
      if (searchedType.length === 0) {
        this.displayedTypes = this.types;
      } else {
        this.displayedTypes = this.types.filter(
          type => type.label.toUpperCase().includes(searchedType.toUpperCase())
        )
      }
    });
  }

  private refreshRemovableTypesMap() {
    this.removableTypeIdsMap = this.types.reduce((map, type) => ({...map, [type.id]: this.removableTypesId.includes(type.id)}), {});
  }
}
